// extracted by mini-css-extract-plugin
module.exports = {"Cards":"Portfolio_Cards__3u3OJ","h1":"Portfolio_h1__B47rq"};